import store from '@/store'
import { Entity } from '@/store/entity'

export class RefundRescueCode extends Entity {
  get rescueCode() {
    const rescueCode = store.getters['rescueCodes/getRescueCode'](this.code)

    if (!rescueCode) {
      store.dispatch('rescueCodes/fetchRescueCode', this.code)
    }

    return rescueCode
  }

  get amountFormatted() {
    return this.formatCurrency(this.amount);
  }
}
